var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({style:(_vm.style),attrs:{"flat":"","icon":"","small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"color":"info"}},[_vm._v("info")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }